module.exports = __webpack_public_path__ + "static/img/3.93c66e4.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/sp/3.png
// module id = PyPw
// module chunks = 0